export default __webpack_public_path__ + "static/gym_2-b7cbb9ecc1105b6a547bc3782d4b263c.png";